import { signal } from "@preact/signals-react"

export const historicalDataRowClick = signal({})